import { Box, Loader, ModBox } from '@jfs/ui-new'
import { useRoute } from '@react-navigation/native'
import { embedDashboard } from '@superset-ui/embedded-sdk'
import { useCallback, useEffect, useState } from 'react'
import EmptyView from '../../comps/EmptyView'
import { useStores } from '../../data/store'

const SupersetEmbedded = () => {
  const { fetchSupersetGuestTokens } = useStores((store) => ({
    fetchSupersetGuestTokens: store?.superset?.fetchSupersetGuestTokens,
  }))
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [isFullscreen, setIsFullscreen] = useState(false)
  const routes: any = useRoute()

  const { REACT_APP_SUPERSET_BASE_URL: supersetUrl } = (window?._env_ ?? {})

  console.log('routes?.params?.dashboardId', routes?.params?.dashboardId)

  const loadDashboard = useCallback(() => {
    setIsLoading(true)
    setErrorMessage('')
    const internalEmbedDashboard = async () => {
      const element = document.getElementById('dashboard-container')

      if (element) {
        console.log('element is defined')
        try {
          const response = await embedDashboard({
            id: routes?.params?.dashboardId,
            supersetDomain: supersetUrl,
            mountPoint: element,
            fetchGuestToken: fetchSupersetGuestTokens, // Only if authentication is required
          })
          console.log('htag response =', response)
        } catch (error) {
          console.log('htag error =', error)
          console.log('Superset error occurred')
          setErrorMessage('An errror has occured while loading dashboard')
        }
        if (element.children[0]) {
          element.children[0].width = '100%'
          element.children[0].height = '100%'
        }
        if (element.querySelector('iframe')) {
          element.querySelector('iframe').style.border = 'none'
        }
        ///element.querySelector('iframe').style.backgroundColor = '#40f0f0'
        setIsLoading(false)
      } else {
        console.log('element is not defined')
      }
    }
    document.addEventListener('fullscreenchange', function () {
      if (!document.fullscreenElement) {
        console.log('Fullscreen mode exited')
        setIsFullscreen(false)
        // Add any other logic you want to execute when exiting fullscreen
      }
    })

    internalEmbedDashboard()
  }, [fetchSupersetGuestTokens, routes?.params?.dashboardId, supersetUrl])

  useEffect(() => {
    loadDashboard()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routes?.params?.dashboardId])

  return (
    <Box height="100%" width="100%" nativeID={'fullscreen-container'}>
      <div id="dashboard-container" style={{ height: '100%', width: '100%', zIndex: 0 }} />
      <ModBox
        position={'absolute'}
        justify="center"
        alignItems={'center'}
        backgroundColor={'WHITE'}
        left={0}
        right={0}
        top={0}
        bottom={0}
        show={isLoading}>
        <Loader type="small" color="PRIMARY" />
      </ModBox>

      {errorMessage && (
        <Box
          position={'absolute'}
          justify="center"
          alignItems={'center'}
          right={0}
          top={0}
          left={0}
          bottom={0}
          backgroundColor={'WHITE'}
          justifyContent={'center'}>
          <EmptyView onRetry={() => loadDashboard()} isLoading={false} error={errorMessage} />
        </Box>
      )}
    </Box>
  )
}

export default SupersetEmbedded
